import { getLanguageCurrentLocal } from "helpers";
import { createApiAction } from "services/api";
import {
  StartAction,
  SuccessAction,
  FailureAction,
} from "services/api/redux/types";

/*--------------------------------------------------------------------
  LANGUAGES
-------------------------------------------------------------------- */

export enum LanguageActionTypes {
  FETCH_LANGUAGES_START = "languages/fetch_languages_start",
  FETCH_LANGUAGES_SUCCESS = "languages/fetch_languages_success",
  FETCH_LANGUAGES_FAILURE = "languages/fetch_languages_failure",
}

// LANGUAGE ACTIONS
const fetchLanguagesActionStart = (): StartAction => ({
  type: LanguageActionTypes.FETCH_LANGUAGES_START,
  payload: null,
});

const fetchLanguagesActionSuccess = (payload: any): SuccessAction => {
  return {
    type: LanguageActionTypes.FETCH_LANGUAGES_SUCCESS,
    payload,
  };
};

const fetchLanguagesActionFailure = (error: string): FailureAction => ({
  type: LanguageActionTypes.FETCH_LANGUAGES_FAILURE,
  payload: { error },
});

export const fetchLanguages = () =>
  createApiAction(
    {
      path: `/v1/translations/languages?translationLanguageId=${getLanguageCurrentLocal()}`,
      method: "GET",
    },
    fetchLanguagesActionStart,
    fetchLanguagesActionSuccess,
    fetchLanguagesActionFailure
  );
